var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReply = function SvgReply(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49588 0.151582C9.19033 0.0198768 8.83572 0.0825481 8.59383 0.311004L1.09383 7.39434C0.927145 7.55176 0.832684 7.77091 0.832684 8.00018C0.832684 8.22945 0.927145 8.4486 1.09383 8.60603L8.59383 15.6894C8.83572 15.9178 9.19033 15.9805 9.49588 15.8488C9.80143 15.7171 9.99935 15.4162 9.99935 15.0835V11.3539C10.9965 11.4176 12.2423 11.5707 13.4866 11.9145C15.1284 12.3681 16.6776 13.1287 17.6882 14.3618C17.9114 14.6341 18.2816 14.7367 18.6132 14.6182C18.9447 14.4997 19.166 14.1856 19.166 13.8335C19.166 9.92277 17.4063 7.54224 15.2371 6.15002C13.4624 5.01104 11.4505 4.55329 9.99935 4.36927V0.916849C9.99935 0.584124 9.80143 0.283287 9.49588 0.151582ZM8.33268 2.85013V5.12145C8.33268 5.55661 8.66751 5.9185 9.10135 5.95227C10.4305 6.05571 12.561 6.41289 14.3369 7.55267C15.6669 8.40629 16.8287 9.71461 17.2889 11.7896C16.2417 11.0877 15.0625 10.6208 13.9305 10.308C12.1162 9.80679 10.3316 9.67609 9.1841 9.65118C8.96001 9.64632 8.7434 9.73194 8.58319 9.8887C8.42298 10.0455 8.33268 10.2602 8.33268 10.4843V13.1502L2.87968 8.00018L8.33268 2.85013Z",
    fill: "#082244"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReply, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reply.6ffb8f55.svg";
export { ForwardRef as ReactComponent };